import { ReactNode, useState } from "react";
import { SheetContextProvider, sheetCtx } from "./context";

export function SheetContext({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [titleExtras, setTitleExtras] = useState<ReactNode | undefined>(
    undefined
  );

  const close = (navigateFn: () => void) => {
    setOpen(false);
    setTimeout(() => {
      navigateFn();
    }, 150);
  };
  return (
    <SheetContextProvider.Provider
      value={{
        open,
        close,
        isLoading,
        setIsLoading,
        title,
        setTitle,
        setTitleExtras: setTitleExtras as sheetCtx["setTitleExtras"],
        titleExtras: titleExtras as sheetCtx["titleExtras"],
      }}
    >
      {children}
    </SheetContextProvider.Provider>
  );
}
